export default "__VITE_ASSET__DbwxZNWe__"